<script>
import { markRaw } from 'vue';

import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

import FilterFormSidebar from './Part/FilterFormSidebar.vue';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            filterFormSidebar: markRaw(FilterFormSidebar),

            routeName: 'branch',
        }
    },
    methods: {
        async _search() {
            var search = this.search;

            if (!search.order_by) {
                search.order_by = 'created_at';
                search.sort_by = 'desc';
            }

            return await this.$api.Branch.all(search);
        },
        async _delete(params) {
            return await this.$api.Branch.delete(params)
        },
        async _restore(id) {
            return await this.$api.Branch.restore(id);
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader
            :title="search.is_deleted == 0 || search.is_deleted == null ? $t('branch.title.list') : $t('branch.title.list') + '' + $t('basic.title.deleted')"
            :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="g-4 align-items-center mb-3">
            <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <BButton type="button" variant="dark"
                        @click="$router.push({ name: routeName, query: { page: 1, is_deleted: 1 } })"
                        v-if="(search.is_deleted == 0 || search.is_deleted == null) && $ac.hasAccess('branch_full_access')">
                        <i class="mdi mdi-delete-empty-outline align-bottom me-1"></i> {{ $t('basic.btn.trash') }}
                    </BButton>
                    <BButton type="button" variant="info" class="add-btn" id="trash-btn"
                        v-if="search.is_deleted == 1 && ($ac.hasAccess('branch_full_access') || $ac.hasAccess('branch_list'))"
                        :to="{ name: routeName, query: { page: 1, is_deleted: 0 } }">
                        <i class="mdi mdi-keyboard-backspace align-bottom me-1"></i> {{ $t('basic.btn.list') }}
                    </BButton>
                    <btn-sidebar variant="primary"
                        v-if="$ac.hasAccess('branch_full_access') || $ac.hasAccess('branch_list')"
                        :sidebar="filterFormSidebar" :success="onSubmitFilter">
                        <i class="mdi mdi-filter-outline align-bottom me-1"></i> {{ $t('basic.btn.filter') }}
                    </btn-sidebar>
                    <BButton type="button" variant="danger" class="add-btn" @click="clear"
                        v-if="hasActiveFilter && ($ac.hasAccess('branch_full_access') || $ac.hasAccess('branch_list'))">
                        <i class="mdi mdi-close-thick align-bottom me-1"></i> {{ $t('basic.btn.clear') }}
                    </BButton>
                </div>
            </BCol>
            <BCol sm>
                <div class="d-flex justify-content-sm-end">
                    <div class="search-box ms-2">
                        <b-form @submit="doSearch()">
                            <input type="text" class="form-control" v-model="search.keyword"
                                :placeholder="$t('filter.placeholder.keyword')" />
                            <i class="mdi mdi-magnify search-icon"></i>
                        </b-form>
                    </div>
                </div>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th class="cursor-pointer" @click="sortBy('ref_no')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('branch.label.ref_no') }}
                                                        <sortable :order="$orderBy.getClass('ref_no')" />
                                                    </div>
                                                </th>
                                                <th class="cursor-pointer" @click="sortBy('store')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('branch.label.store') }}
                                                        <sortable :order="$orderBy.getClass('store')" />
                                                    </div>
                                                </th>
                                                <th class="cursor-pointer" @click="sortBy('name')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('branch.label.name') }}
                                                        <sortable :order="$orderBy.getClass('name')" />
                                                    </div>
                                                </th>
                                                <th class="cursor-pointer" @click="sortBy('status')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('branch.label.status') }}
                                                        <sortable :order="$orderBy.getClass('status')" />
                                                    </div>
                                                </th>
                                                <th class="cursor-pointer" @click="sortBy('created_at')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('basic.label.created') }}
                                                        <sortable :order="$orderBy.getClass('created_at')" />
                                                    </div>
                                                </th>
                                                <th style="width: 150px;"
                                                    v-if="search.is_deleted == 1 && ($ac.hasAccess('branch_full_access') || ($ac.hasAccesses(['branch_delete', 'branch_restore', 'branch_delete_permanent'])))">
                                                    {{ $t('basic.label.action') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tr, index) in list" :key="index" @click="
                                                (search.is_deleted == 0 || search.is_deleted == null) &&
                                                ($ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_show') && ($ac.hasAccessStore(tr.store_id) || $ac.hasAccessBranch(tr.id)))) &&
                                                ($router.push({ name: 'branch-detail', params: { id: tr.id } }))"
                                                :class="[
                                                    search.is_deleted == 0 || search.is_deleted == null && ($ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_show') && ($ac.hasAccessStore(tr.store_id) || $ac.hasAccessBranch(tr.id)))) ? 'cursor-pointer' : ''
                                                ]">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.ref_no }}</td>
                                                <td>
                                                    {{ tr.store }}
                                                    <br><span class="text-body-secondary">{{ tr.store_ref_no }}</span>
                                                </td>
                                                <td>{{ tr.name }}</td>
                                                <td>
                                                    <BBadge variant="success" v-if="tr.is_open == 1">{{
                                                        $t('branch.status.open') }}</BBadge>
                                                    <BBadge variant="danger" v-if="tr.is_open == 0">{{
                                                        $t('branch.status.closed') }}</BBadge>
                                                </td>
                                                <td>{{ $dateFormat.datetime(tr.created_at) }}</td>
                                                <td @click.stop
                                                    v-if="search.is_deleted == 1 && ($ac.hasAccess('branch_full_access') || ($ac.hasAccesses(['branch_restore', 'branch_delete_permanent'])))">
                                                    <BDropdown variant="primary" no-caret size="md" strategy="fixed"
                                                        :toggle-class="{
                                                            'no-caret': $loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))
                                                        }"
                                                        :disabled="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))">
                                                        <template #button-content
                                                            class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                            <loading
                                                                :loading="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))"
                                                                variant="light" type="button">
                                                                {{ $t('basic.btn.action') }}
                                                            </loading>
                                                        </template>
                                                        <template v-if="search.is_deleted == 1">
                                                            <BDropdownItem @click.prevent="restore(tr.id)"
                                                                variant="success"
                                                                v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_restore'))">
                                                                <i class="mdi mdi-restore fs-16"></i> {{
                                                                    $t('basic.btn.restore') }}
                                                            </BDropdownItem>
                                                            <BDropdownItem @click.prevent="destroy(tr.id, 1)"
                                                                variant="danger"
                                                                v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_delete_permanent'))">
                                                                <i class="mdi mdi-eraser fs-16"></i> {{
                                                                    $t('basic.btn.delete_permanent') }}
                                                            </BDropdownItem>
                                                        </template>
                                                    </BDropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>